import {
  SubmissionDocument,
  SubmissionProof,
} from '../template/TemplateQuestion/types'
import { plainToInstance, Type } from 'class-transformer'
import { IInspectionItemAnswer } from './IInspectionItemAnswer'
import { InspectionItemAnswerType } from './types'
import { Entity } from '@core/entities/entity'
import { TaskPayload } from '@core/entities/InspectionItemAnswer/TaskPayload'
import { InspectionTask } from '@core/entities/InspectionItemAnswer/InspectionTask'
import { Palette } from '@core/theme/color-palette-siteassist'

export class InspectionItemAnswer extends Entity<IInspectionItemAnswer> {
  inspectionItemAnswerType: InspectionItemAnswerType

  submissionProofs?: Array<SubmissionProof>

  submissionDocuments?: Array<SubmissionDocument>

  submissionText?: string

  first: boolean

  @Type(() => InspectionTask)
  inspectionTask?: InspectionTask

  @Type(() => TaskPayload)
  taskPayload?: TaskPayload

  @Type(() => TaskPayload)
  taskPayloadResult?: TaskPayload

  public static new(payload: unknown): InspectionItemAnswer {
    const entity = plainToInstance(InspectionItemAnswer, payload)

    return entity
  }

  public static getAnswerTypeConfigColors(
    inspectionItemAnswerType: InspectionItemAnswerType,
  ) {
    const optionButtonsConfig = {
      YES: {
        default: {
          backgroundColor: Palette.Green[50],
          borderColor: Palette.Green[800],
          iconColor: Palette.Green[800],
        },
        selected: {
          backgroundColor: Palette.Green[400],
          borderColor: Palette.Green[400],
          iconColor: Palette.Common.White,
        },
      },
      NO: {
        default: {
          backgroundColor: Palette.Red[50],
          borderColor: Palette.Red[900],
          iconColor: Palette.Red[900],
        },
        selected: {
          backgroundColor: Palette.Red[500],
          borderColor: Palette.Red[500],
          iconColor: Palette.Common.White,
        },
      },
      NA: {
        default: {
          backgroundColor: Palette.BlueGrey[50],
          borderColor: Palette.BlueGrey[700],
          iconColor: Palette.BlueGrey[700],
        },
        selected: {
          backgroundColor: Palette.BlueGrey[500],
          borderColor: Palette.BlueGrey[500],
          iconColor: Palette.Common.White,
        },
      },
    }
    return optionButtonsConfig[inspectionItemAnswerType]
  }
}
